import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=bf21a500&"
import script from "./DrawerMenu.vue?vue&type=script&lang=ts&"
export * from "./DrawerMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf21a500')) {
      api.createRecord('bf21a500', component.options)
    } else {
      api.reload('bf21a500', component.options)
    }
    module.hot.accept("./DrawerMenu.vue?vue&type=template&id=bf21a500&", function () {
      api.rerender('bf21a500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/utilities/DrawerMenu.vue"
export default component.exports